import React from "react";
import { Grid, Paper, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { AuthContext } from "../../components/auth/AuthContext.js";
import Loader from "../../components/loader/index.jsx";
import { useSnackbar } from "../../components/toast/index.jsx";
import { PROFILE_UPDATE_FAILED, PROFILE_UPDATE_SUCCESS } from "../../helpers/messages.js";
import Utils from "../../utils.js";
import ChangePasswordForm from "./change-password.jsx";
import { ProfilePageSchema } from "./validator.js";
import Input from "../../components/common-form/text-input/index.jsx";
import CommonFormikComponent from "../../components/common-form/index.jsx";

function App() {
    const [user, setUser] = React.useState({});
    const [dataLoaded, setDataLoaded] = React.useState(false);
    const [spinner, setSpinner] = React.useState(false);
    const showSnackbar = useSnackbar();
    const { refreshUser } = React.useContext(AuthContext);

    async function getCompanyData() {
        Utils.sendProgressBar(true);
        setSpinner(true)
        try {
            const cognitoUser = await Utils.getUserName();
            const userDetails = await Utils.genericGet("getUser", cognitoUser.username);
            setUser(userDetails.data.getUser);
            setSpinner(false);
        } catch (error) {
            console.log(error);
            setSpinner(false);
        }
    }

    React.useEffect(() => {
        if (!dataLoaded) {
            const fetchData = async () => {
                await getCompanyData(); // Your async data fetching function
                setDataLoaded(true); // Mark data as loaded
            };
            fetchData();
        }
        window.scrollTo(0, 0); // Scroll to top when component mounts
    }, [dataLoaded]);

    /**
     * Initial Form Values
     */
    const initialValues = {
        firstname: user?.firstname || "",
        lastname: user?.lastname || "",
    };

    /**
     * Submit Method to call when user save button
     * @async
     * @param {FormValues} values
     * @param {any} actions
     * @returns {*}
     */
    const submitForm = async (values, { setSubmitting }) => {
        setSubmitting(true);
        Utils.sendProgressBar(true);
        try {
            await Utils.genericMutation("updateUser", {
                id: user.id,
                firstname: values.firstname,
                lastname: values.lastname,
            });
            setSubmitting(false);
            showSnackbar(PROFILE_UPDATE_SUCCESS);
            refreshUser();
        } catch (error) {
            console.log(error);
            setSubmitting(false);
            showSnackbar(PROFILE_UPDATE_FAILED, "error");
        }
        await Utils.refreshUserGroups();
    };

    return (
        <Grid display="flex" flexDirection="column" flexGrow="1" overflow="auto">
            {spinner && <Loader />}
            <Grid
                className="vocalysed-home-upadted profile"
                container
                spacing={0}
                direction="column"
                flexWrap="nowrap"
                flexGrow={1}
                paddingTop={2}
                paddingX={3}
                paddingBottom={3}
                overflow="auto"
                gap={3}
            >
                <Paper
                    sx={{ display: "flex", flexDirection: "column", flexGrow: 1, width: '100%', borderRadius: 2.5, padding: 3, boxSizing: "border-box" }}
                >
                    <CommonFormikComponent
                        validationSchema={ProfilePageSchema}
                        initialValues={initialValues}
                        onSubmit={submitForm}
                        formClassName="d-flex flex-column flex-grow-1 overflow-auto"
                    >
                        {(formikProps) => (
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
                                        Profile Details
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                                    <Input
                                        label="First Name"
                                        name="firstname"
                                        value={formikProps.values.firstname}
                                        onChange={formikProps.handleChange}
                                        onBlur={formikProps.handleBlur}
                                        error={formikProps.errors.firstname}
                                        touched={formikProps.touched.firstname}
                                        validationSchema={ProfilePageSchema}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                                    <Input
                                        label="Last Name"
                                        name="lastname"
                                        value={formikProps.values.lastname}
                                        onChange={formikProps.handleChange}
                                        onBlur={formikProps.handleBlur}
                                        error={formikProps.errors.lastname}
                                        touched={formikProps.touched.lastname}
                                        validationSchema={ProfilePageSchema}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        disabled={formikProps.isSubmitting}
                                        size="large"
                                    >
                                        {formikProps.isSubmitting ? "Saving..." : "Save Changes"}
                                    </Button>
                                </Grid>
                            </Grid>
                        )}
                    </CommonFormikComponent>
                    <ChangePasswordForm />
                </Paper>
            </Grid>
        </Grid>
    );
}

export default App;
